export default function getCountryStates(country) {
  const all = {
    AU: [
      {
        label: 'Australian Capital Territory',
        value: 'ACT',
      },
      {
        label: 'New South Wales',
        value: 'NSW',
      },
      {
        label: 'Northern Territory',
        value: 'NT',
      },
      {
        label: 'Queensland',
        value: 'QLD',
      },
      {
        label: 'South Australia',
        value: 'SA',
      },
      {
        label: 'Tasmania',
        value: 'TAS',
      },
      {
        label: 'Victoria',
        value: 'VIC',
      },
      {
        label: 'Western Australia',
        value: 'WA',
      },
    ],

    NZ: [
      {
        label: 'Australian Capital Territory',
        value: 'ACT',
      },
      {
        label: 'New South Wales',
        value: 'NSW',
      },
      {
        label: 'Northern Territory',
        value: 'NT',
      },
      {
        label: 'Queensland',
        value: 'QLD',
      },
      {
        label: 'South Australia',
        value: 'SA',
      },
      {
        label: 'Tasmania',
        value: 'TAS',
      },
      {
        label: 'Victoria',
        value: 'VIC',
      },
      {
        label: 'Western Australia',
        value: 'WA',
      },
    ],

    US: [
      {
        label: 'Alabama',
        value: 'AL',
      },
      {
        label: 'Alaska',
        value: 'AK',
      },
      {
        label: 'Arizona',
        value: 'AZ',
      },
      {
        label: 'Arkansas',
        value: 'AR',
      },
      {
        label: 'California',
        value: 'CA',
      },
      {
        label: 'Colorado',
        value: 'CO',
      },
      {
        label: 'Connecticut',
        value: 'CT',
      },
      {
        label: 'Delaware',
        value: 'DE',
      },
      {
        label: 'Washington, D.C.',
        value: 'DC',
      },
      {
        label: 'Florida',
        value: 'FL',
      },
      {
        label: 'Georgia',
        value: 'GA',
      },
      {
        label: 'Hawaii',
        value: 'HI',
      },
      {
        label: 'Idaho',
        value: 'ID',
      },
      {
        label: 'Illinois',
        value: 'IL',
      },
      {
        label: 'Indiana',
        value: 'IN',
      },
      {
        label: 'Iowa',
        value: 'IA',
      },
      {
        label: 'Kansas',
        value: 'KS',
      },
      {
        label: 'Kentucky',
        value: 'KY',
      },
      {
        label: 'Louisiana',
        value: 'LA',
      },
      {
        label: 'Maine',
        value: 'ME',
      },
      {
        label: 'Maryland',
        value: 'MD',
      },
      {
        label: 'Massachusetts',
        value: 'MA',
      },
      {
        label: 'Michigan',
        value: 'MI',
      },
      {
        label: 'Minnesota',
        value: 'MN',
      },
      {
        label: 'Mississippi',
        value: 'MS',
      },
      {
        label: 'Missouri',
        value: 'MO',
      },
      {
        label: 'Montana',
        value: 'MT',
      },
      {
        label: 'Nebraska',
        value: 'NE',
      },
      {
        label: 'Nevada',
        value: 'NV',
      },
      {
        label: 'New Hampshire',
        value: 'NH',
      },
      {
        label: 'New Jersey',
        value: 'NJ',
      },
      {
        label: 'New Mexico',
        value: 'NM',
      },
      {
        label: 'New York',
        value: 'NY',
      },
      {
        label: 'North Carolina',
        value: 'NC',
      },
      {
        label: 'North Dakota',
        value: 'ND',
      },
      {
        label: 'Ohio',
        value: 'OH',
      },
      {
        label: 'Oklahoma',
        value: 'OK',
      },
      {
        label: 'Oregon',
        value: 'OR',
      },
      {
        label: 'Pennsylvania',
        value: 'PA',
      },
      {
        label: 'Rhode Island',
        value: 'RI',
      },
      {
        label: 'South Carolina',
        value: 'SC',
      },
      {
        label: 'South Dakota',
        value: 'SD',
      },
      {
        label: 'Tennessee',
        value: 'TN',
      },
      {
        label: 'Texas',
        value: 'TX',
      },
      {
        label: 'Utah',
        value: 'UT',
      },
      {
        label: 'Vermont',
        value: 'VT',
      },
      {
        label: 'Virginia',
        value: 'VA',
      },
      {
        label: 'Washington',
        value: 'WA',
      },
      {
        label: 'West Virginia',
        value: 'WV',
      },
      {
        label: 'Wisconsin',
        value: 'WI',
      },
      {
        label: 'Wyoming',
        value: 'WY',
      },
    ],

    CN: [
      { label: '安徽省 (Anhui)', value: 'AH' },
      { label: '北京市 (Beijing)', value: 'BJ' },
      { label: '重庆市 (Chongqing)', value: 'CQ' },
      { label: '福建省 (Fujian)', value: 'FJ' },
      { label: '甘肃省 (Gansu)', value: 'GS' },
      { label: '广东省 (Guangdong)', value: 'GD' },
      { label: '广西壮族自治区 (Guangxi)', value: 'GX' },
      { label: '贵州省 (Guizhou)', value: 'GZ' },
      { label: '海南省 (Hainan)', value: 'HI' },
      { label: '河北省 (Hebei)', value: 'HE' },
      { label: '黑龙江省 (Heilongjiang)', value: 'HL' },
      { label: '河南省 (Henan)', value: 'HA' },
      { label: '香港特别行政区 (Hong Kong)', value: 'HK' },
      { label: '湖北省 (Hubei)', value: 'HB' },
      { label: '湖南省 (Hunan)', value: 'HN' },
      { label: '内蒙古自治区 (Inner Mongolia)', value: 'NM' },
      { label: '江苏省 (Jiangsu)', value: 'JS' },
      { label: '江西省 (Jiangxi)', value: 'JX' },
      { label: '吉林省 (Jilin)', value: 'JL' },
      { label: '辽宁省 (Liaoning)', value: 'LN' },
      { label: '澳门特别行政区 (Macau)', value: 'MO' },
      { label: '宁夏回族自治区 (Ningxia)', value: 'NX' },
      { label: '青海省 (Qinghai)', value: 'QH' },
      { label: '陕西省 (Shaanxi)', value: 'SN' },
      { label: '山东省 (Shandong)', value: 'SD' },
      { label: '上海市 (Shanghai)', value: 'SH' },
      { label: '山西省 (Shanxi)', value: 'SX' },
      { label: '四川省 (Sichuan)', value: 'SC' },
      { label: '台湾省 (Taiwan)', value: 'TW' },
      { label: '天津市 (Tianjin)', value: 'TJ' },
      { label: '西藏自治区 (Tibet)', value: 'XZ' },
      { label: '新疆维吾尔自治区 (Xinjiang)', value: 'XJ' },
      { label: '云南省 (Yunnan)', value: 'YN' },
      { label: '浙江省 (Zhejiang)', value: 'ZJ' },
    ],

    CA: [
      {
        label: 'Alberta',
        value: 'AB',
      },
      {
        label: 'Colúmbia Britànica',
        value: 'BC',
      },
      {
        label: 'Illa del Príncep Eduard',
        value: 'PE',
      },
      {
        label: 'Manitoba',
        value: 'MB',
      },
      {
        label: 'Newfoundland',
        value: 'NL',
      },
      {
        label: 'Northwest Territories',
        value: 'NT',
      },
      {
        label: 'Nova Brunsvic',
        value: 'NB',
      },
      {
        label: 'Nova Escòcia',
        value: 'NS',
      },
      {
        label: 'Nunavut',
        value: 'NU',
      },
      {
        label: 'Ontàrio',
        value: 'ON',
      },
      {
        label: 'Québec',
        value: 'QC',
      },
      {
        label: 'Saskatchewan',
        value: 'SK',
      },
      {
        label: 'Yukon',
        value: 'YT',
      },
    ],

    BR: [
      { label: 'Acre', value: 'AC' },
      { label: 'Alagoas', value: 'AL' },
      { label: 'Amapá', value: 'AP' },
      { label: 'Amazonas', value: 'AM' },
      { label: 'Bahia', value: 'BA' },
      { label: 'Ceará', value: 'CE' },
      { label: 'Distrito Federal', value: 'DF' },
      { label: 'Espírito Santo', value: 'ES' },
      { label: 'Goiás', value: 'GO' },
      { label: 'Maranhão', value: 'MA' },
      { label: 'Mato Grosso', value: 'MT' },
      { label: 'Mato Grosso do Sul', value: 'MS' },
      { label: 'Minas Gerais', value: 'MG' },
      { label: 'Pará', value: 'PA' },
      { label: 'Paraíba', value: 'PB' },
      { label: 'Paraná', value: 'PR' },
      { label: 'Pernambuco', value: 'PE' },
      { label: 'Piauí', value: 'PI' },
      { label: 'Rio de Janeiro', value: 'RJ' },
      { label: 'Rio Grande do Norte', value: 'RN' },
      { label: 'Rio Grande do Sul', value: 'RS' },
      { label: 'Rondônia', value: 'RO' },
      { label: 'Roraima', value: 'RR' },
      { label: 'Santa Catarina', value: 'SC' },
      { label: 'São Paulo', value: 'SP' },
      { label: 'Sergipe', value: 'SE' },
      { label: 'Tocantins', value: 'TO' },
    ],

    IN: [
      { label: 'Andaman and Nicobar Islands', value: 'AN' },
      { label: 'Andhra Pradesh', value: 'AP' },
      { label: 'Arunachal Pradesh', value: 'AR' },
      { label: 'Assam', value: 'AS' },
      { label: 'Bihar', value: 'BR' },
      { label: 'Chandigarh', value: 'CH' },
      { label: 'Chhattisgarh', value: 'CT' },
      {
        label: 'Dadra and Nagar Haveli and Daman and Diu',
        value: 'DH',
      },
      { label: 'Delhi', value: 'DL' },
      { label: 'Goa', value: 'GA' },
      { label: 'Gujarat', value: 'GJ' },
      { label: 'Haryana', value: 'HR' },
      { label: 'Himachal Pradesh', value: 'HP' },
      { label: 'Jammu and Kashmir', value: 'JK' },
      { label: 'Jharkhand', value: 'JH' },
      { label: 'Karnataka', value: 'KA' },
      { label: 'Kerala', value: 'KL' },
      { label: 'Ladakh', value: 'LA' },
      { label: 'Lakshadweep', value: 'LD' },
      { label: 'Madhya Pradesh', value: 'MP' },
      { label: 'Maharashtra', value: 'MH' },
      { label: 'Manipur', value: 'MN' },
      { label: 'Meghalaya', value: 'ML' },
      { label: 'Mizoram', value: 'MZ' },
      { label: 'Nagaland', value: 'NL' },
      { label: 'Odisha', value: 'OR' },
      { label: 'Puducherry', value: 'PY' },
      { label: 'Punjab', value: 'PB' },
      { label: 'Rajasthan', value: 'RJ' },
      { label: 'Sikkim', value: 'SK' },
      { label: 'Tamil Nadu', value: 'TN' },
      { label: 'Telangana', value: 'TG' },
      { label: 'Tripura', value: 'TR' },
      { label: 'Uttar Pradesh', value: 'UP' },
      { label: 'Uttarakhand', value: 'UK' },
      { label: 'West Bengal', value: 'WB' },
    ],

    JP: [
      { label: '北海道 (Hokkaido)', value: 'JP-01' },
      { label: '青森県 (Aomori)', value: 'JP-02' },
      { label: '岩手県 (Iwate)', value: 'JP-03' },
      { label: '宮城県 (Miyagi)', value: 'JP-04' },
      { label: '秋田県 (Akita)', value: 'JP-05' },
      { label: '山形県 (Yamagata)', value: 'JP-06' },
      { label: '福島県 (Fukushima)', value: 'JP-07' },
      { label: '茨城県 (Ibaraki)', value: 'JP-08' },
      { label: '栃木県 (Tochigi)', value: 'JP-09' },
      { label: '群馬県 (Gunma)', value: 'JP-10' },
      { label: '埼玉県 (Saitama)', value: 'JP-11' },
      { label: '千葉県 (Chiba)', value: 'JP-12' },
      { label: '東京都 (Tokyo)', value: 'JP-13' },
      { label: '神奈川県 (Kanagawa)', value: 'JP-14' },
      { label: '新潟県 (Niigata)', value: 'JP-15' },
      { label: '富山県 (Toyama)', value: 'JP-16' },
      { label: '石川県 (Ishikawa)', value: 'JP-17' },
      { label: '福井県 (Fukui)', value: 'JP-18' },
      { label: '山梨県 (Yamanashi)', value: 'JP-19' },
      { label: '長野県 (Nagano)', value: 'JP-20' },
      { label: '岐阜県 (Gifu)', value: 'JP-21' },
      { label: '静岡県 (Shizuoka)', value: 'JP-22' },
      { label: '愛知県 (Aichi)', value: 'JP-23' },
      { label: '三重県 (Mie)', value: 'JP-24' },
      { label: '滋賀県 (Shiga)', value: 'JP-25' },
      { label: '京都府 (Kyoto)', value: 'JP-26' },
      { label: '大阪府 (Osaka)', value: 'JP-27' },
      { label: '兵庫県 (Hyogo)', value: 'JP-28' },
      { label: '奈良県 (Nara)', value: 'JP-29' },
      { label: '和歌山県 (Wakayama)', value: 'JP-30' },
      { label: '鳥取県 (Tottori)', value: 'JP-31' },
      { label: '島根県 (Shimane)', value: 'JP-32' },
      { label: '岡山県 (Okayama)', value: 'JP-33' },
      { label: '広島県 (Hiroshima)', value: 'JP-34' },
      { label: '山口県 (Yamaguchi)', value: 'JP-35' },
      { label: '徳島県 (Tokushima)', value: 'JP-36' },
      { label: '香川県 (Kagawa)', value: 'JP-37' },
      { label: '愛媛県 (Ehime)', value: 'JP-38' },
      { label: '高知県 (Kochi)', value: 'JP-39' },
      { label: '福岡県 (Fukuoka)', value: 'JP-40' },
      { label: '佐賀県 (Saga)', value: 'JP-41' },
      { label: '長崎県 (Nagasaki)', value: 'JP-42' },
      { label: '熊本県 (Kumamoto)', value: 'JP-43' },
      { label: '大分県 (Oita)', value: 'JP-44' },
      { label: '宮崎県 (Miyazaki)', value: 'JP-45' },
      { label: '鹿児島県 (Kagoshima)', value: 'JP-46' },
      { label: '沖縄県 (Okinawa)', value: 'JP-47' },
    ],

    MX: [
      { label: 'Aguascalientes', value: 'AG' },
      { label: 'Baja California', value: 'BC' },
      { label: 'Baja California Sur', value: 'BS' },
      { label: 'Campeche', value: 'CM' },
      { label: 'Chiapas', value: 'CS' },
      { label: 'Chihuahua', value: 'CH' },
      { label: 'Ciudad de México', value: 'DF' },
      { label: 'Coahuila', value: 'CO' },
      { label: 'Colima', value: 'CL' },
      { label: 'Durango', value: 'DG' },
      { label: 'Guanajuato', value: 'GT' },
      { label: 'Guerrero', value: 'GR' },
      { label: 'Hidalgo', value: 'HG' },
      { label: 'Jalisco', value: 'JA' },
      { label: 'México', value: 'ME' },
      { label: 'Michoacán', value: 'MI' },
      { label: 'Morelos', value: 'MO' },
      { label: 'Nayarit', value: 'NA' },
      { label: 'Nuevo León', value: 'NL' },
      { label: 'Oaxaca', value: 'OA' },
      { label: 'Puebla', value: 'PU' },
      { label: 'Querétaro', value: 'QT' },
      { label: 'Quintana Roo', value: 'QR' },
      { label: 'San Luis Potosí', value: 'SL' },
      { label: 'Sinaloa', value: 'SI' },
      { label: 'Sonora', value: 'SO' },
      { label: 'Tabasco', value: 'TB' },
      { label: 'Tamaulipas', value: 'TM' },
      { label: 'Tlaxcala', value: 'TL' },
      { label: 'Veracruz', value: 'VE' },
      { label: 'Yucatán', value: 'YU' },
      { label: 'Zacatecas', value: 'ZA' },
    ],

    MY: [
      { label: 'Johor', value: 'JHR' },
      { label: 'Kedah', value: 'KDH' },
      { label: 'Kelantan', value: 'KTN' },
      { label: 'Kuala Lumpur', value: 'KUL' },
      { label: 'Labuan', value: 'LBN' },
      { label: 'Melaka', value: 'MLK' },
      { label: 'Negeri Sembilan', value: 'NSN' },
      { label: 'Pahang', value: 'PHG' },
      { label: 'Perak', value: 'PRK' },
      { label: 'Perlis', value: 'PLS' },
      { label: 'Pulau Pinang', value: 'PNG' },
      { label: 'Putrajaya', value: 'PJY' },
      { label: 'Sabah', value: 'SBH' },
      { label: 'Sarawak', value: 'SWK' },
      { label: 'Selangor', value: 'SGR' },
      { label: 'Terengganu', value: 'TRG' },
    ],

    PK: [
      { label: 'Azad Jammu and Kashmir', value: 'JK' },
      { label: 'Balochistan', value: 'BA' },
      { label: 'Gilgit-Baltistan', value: 'GB' },
      { label: 'Islamabad Capital Territory', value: 'IS' },
      { label: 'Khyber Pakhtunkhwa', value: 'KP' },
      { label: 'Punjab', value: 'PB' },
      { label: 'Sindh', value: 'SD' },
    ],

    VN: [
      { label: 'An Giang', value: 'AG' },
      { label: 'Bà Rịa - Vũng Tàu', value: 'BR' },
      { label: 'Bắc Giang', value: 'BG' },
      { label: 'Bắc Kạn', value: 'BK' },
      { label: 'Bạc Liêu', value: 'BL' },
      { label: 'Bắc Ninh', value: 'BN' },
      { label: 'Bến Tre', value: 'BT' },
      { label: 'Bình Định', value: 'BD' },
      { label: 'Bình Dương', value: 'BI' },
      { label: 'Bình Phước', value: 'BP' },
      { label: 'Bình Thuận', value: 'BTH' },
      { label: 'Cà Mau', value: 'CM' },
      { label: 'Cần Thơ', value: 'CT' },
      { label: 'Cao Bằng', value: 'CB' },
      { label: 'Đà Nẵng', value: 'DN' },
      { label: 'Đắk Lắk', value: 'DL' },
      { label: 'Đắk Nông', value: 'DNo' },
      { label: 'Điện Biên', value: 'DB' },
      { label: 'Đồng Nai', value: 'DNa' },
      { label: 'Đồng Tháp', value: 'DT' },
      { label: 'Gia Lai', value: 'GL' },
      { label: 'Hà Giang', value: 'HG' },
      { label: 'Hà Nam', value: 'HNa' },
      { label: 'Hà Nội', value: 'HN' },
      { label: 'Hà Tĩnh', value: 'HT' },
      { label: 'Hải Dương', value: 'HD' },
      { label: 'Hải Phòng', value: 'HP' },
      { label: 'Hậu Giang', value: 'HGi' },
      { label: 'Hòa Bình', value: 'HB' },
      { label: 'Hưng Yên', value: 'HY' },
      { label: 'Khánh Hòa', value: 'KH' },
      { label: 'Kiên Giang', value: 'KG' },
      { label: 'Kon Tum', value: 'KT' },
      { label: 'Lai Châu', value: 'LC' },
      { label: 'Lâm Đồng', value: 'LD' },
      { label: 'Lạng Sơn', value: 'LS' },
      { label: 'Lào Cai', value: 'LCa' },
      { label: 'Long An', value: 'LA' },
      { label: 'Nam Định', value: 'ND' },
      { label: 'Nghệ An', value: 'NA' },
      { label: 'Ninh Bình', value: 'NB' },
      { label: 'Ninh Thuận', value: 'NT' },
      { label: 'Phú Thọ', value: 'PT' },
      { label: 'Phú Yên', value: 'PY' },
      { label: 'Quảng Bình', value: 'QB' },
      { label: 'Quảng Nam', value: 'QNa' },
      { label: 'Quảng Ngãi', value: 'QNg' },
      { label: 'Quảng Ninh', value: 'QN' },
      { label: 'Quảng Trị', value: 'QT' },
      { label: 'Sóc Trăng', value: 'ST' },
      { label: 'Sơn La', value: 'SL' },
      { label: 'Tây Ninh', value: 'TN' },
      { label: 'Thái Bình', value: 'TB' },
      { label: 'Thái Nguyên', value: 'TNG' },
      { label: 'Thanh Hóa', value: 'TH' },
      { label: 'Thừa Thiên Huế', value: 'TTH' },
      { label: 'Tiền Giang', value: 'TG' },
      { label: 'TP Hồ Chí Minh', value: 'HCM' },
      { label: 'Trà Vinh', value: 'TV' },
      { label: 'Tuyên Quang', value: 'TQ' },
      { label: 'Vĩnh Long', value: 'VL' },
      { label: 'Vĩnh Phúc', value: 'VP' },
      { label: 'Yên Bái', value: 'YB' },
    ],
  };

  if (country in all) return all[country];
  return [];
}
